<ng-container *ngrxLet="selectExternalStorageList$; let external">
  <ng-container *ngrxLet="selectIsDeveloper$; let isDeveloper">
    <div #wrapper [class.standalone]="standalone" class="ui-tab">
      <div class="h-100 mb-24">
        <form [formGroup]="storage">
          <h4 class="page-title">{{ 'CAMERA_STORAGE_SETTINGS.DATA_RETENTION'|translate }}</h4>
          <div *ifDeveloper class="wrapper narrow-input-40 flex-row start-center mb-16">
            <div class="flex-row start-center gap-8 flex">
              <div>{{ 'CAMERA_STORAGE_SETTINGS.SEARCH_TEXT'|translate }}</div>
            </div>
            <mat-select [placeholder]="'CAMERA_STORAGE_SETTINGS.PLACEHOLDERS.SELECT_PERIOD'|translate" class="ui-selector storage-selector flex ui-selector-40"
                        formControlName="retentionDays">
              <mat-option *ngIf="standalone" [value]="null">{{ 'COMMON.NONE'|translate }}</mat-option>
              <mat-option [value]="30">{{ 'DURATION.30DAYS'|translate }}</mat-option>
              <mat-option [value]="60">{{ 'DURATION.60DAYS'|translate }}</mat-option>
              <mat-option [value]="90">{{ 'DURATION.90DAYS'|translate }}</mat-option>
              <mat-option [value]="365">{{ 'DURATION.365DAYS'|translate }}</mat-option>
            </mat-select>
          </div>
          <div class="wrapper narrow-input-40 flex-row start-center mb-16">
            <div class="flex-row start-center gap-8 flex">
              <div>{{ 'CAMERA_STORAGE_SETTINGS.SNAPSHOT_RETENTION'|translate }}</div>
            </div>
            <mat-select [placeholder]="'CAMERA_STORAGE_SETTINGS.PLACEHOLDERS.SELECT_PERIOD'|translate" class="ui-selector storage-selector ui-selector-40"
                        formControlName="snapshotRetentionDays">
              <mat-option *ngIf="standalone" [value]="null">{{ 'COMMON.NONE'|translate }}</mat-option>
              <mat-option [value]="3">{{ 'DURATION.3DAYS'|translate }}</mat-option>
              <mat-option [value]="7">{{ 'DURATION.7DAYS'|translate }}</mat-option>
              <mat-option [value]="14">{{ 'DURATION.14DAYS'|translate }}</mat-option>
              <mat-option [value]="30">{{ 'DURATION.30DAYS'|translate }}</mat-option>
              <mat-option *ifDeveloper [value]="60">{{ 'DURATION.60DAYS'|translate }}</mat-option>
              <mat-option *ifDeveloper [value]="90">{{ 'DURATION.90DAYS'|translate }}</mat-option>
              <mat-option *ifDeveloper [value]="180">{{ 'DURATION.180DAYS'|translate }}</mat-option>
              <mat-option *ifDeveloper [value]="365">{{ 'DURATION.365DAYS'|translate }}</mat-option>
            </mat-select>
          </div>
          <div *ifDeveloper class="vertical-divider"></div>
          <h4 class="page-title">{{ 'CAMERA_STORAGE_SETTINGS.VIDEO_STORAGE'|translate }}</h4>
          <div class="flex-col narrower-input">
            <div class="wrapper narrow-input-40 flex-row start-center mb-16">
              <div *ngIf="!standalone" class="flex-row start-center gap-8">
                <ui-toggle formControlName="storageEnabled"></ui-toggle>
                <div>{{ 'CAMERA_STORAGE_SETTINGS.STORAGE_ENABLED'|translate }}</div>
              </div>
              <div *ngIf="standalone" class="flex-row start-center gap-8 w-100">
                <div class="flex-row start-center flex">{{ 'CAMERA_STORAGE_SETTINGS.STORAGE_ENABLED'|translate }}</div>
                <mat-select [placeholder]="'BULK_UPDATE_FORM.PLACEHOLDERS.ENABLE_DISABLE'|translate" 
                            class="ui-selector storage-selector flex ui-selector-40"
                            formControlName="storageEnabled">
                  <mat-option [value]="null">{{ 'COMMON.NONE'|translate }}</mat-option>
                  <mat-option [value]="true">{{ 'COMMON.ENABLED'|translate }}</mat-option>
                  <mat-option [value]="false">{{ 'COMMON.DISABLED'|translate }}</mat-option>
                </mat-select>
              </div>
            </div>
            <div class="flex-row stream-select-wrapper mb-16">
              <div class="flex-row start-center gap-8 flex">
                <div>{{ 'CAMERA_STORAGE_SETTINGS.STORAGE_STREAM'|translate }}</div>
              </div>
              <div class="flex-row mb-8">
                <mat-select (selectionChange)="setSmartStorage()"
                            [placeholder]="'CAMERA_STORAGE_SETTINGS.PLACEHOLDERS.SELECT_STREAM'|translate"
                            class="ui-selector ui-selector-40 storage-selector"
                            formControlName="storageStream"
                >
                  <mat-option *ngIf="standalone" [value]="null">{{ 'COMMON.NONE'|translate }}</mat-option>
                  <mat-option value="0">{{ 'CAMERA_STORAGE_SETTINGS.MAIN_STEAM'|translate }}</mat-option>
                  <ng-container *ngIf="standalone; else cameraSubstreamOptions">
                    <mat-option value="1">{{ 'CAMERA_STORAGE_SETTINGS.SUBSTREAM_NUMBER'|translate:{ number: 1 } }}</mat-option>
                  </ng-container>
                  <ng-template #cameraSubstreamOptions>
                    <mat-option *ngFor="let substream of subStreams; let i = index" [value]="(i + 1).toString()">
                      {{ 'CAMERA_STORAGE_SETTINGS.SUBSTREAM_NUMBER'|translate:{ number: i + 1 } }}
                    </mat-option>
                  </ng-template>
                </mat-select>

              </div>
            </div>
            <div class="wrapper narrow-input-40 flex-row start-center mb-16">
              <div class="flex-row start-center gap-8 flex">
                <!--          <ui-toggle formControlName="maxDaysEnabled"></ui-toggle>-->
                <div>{{ 'CAMERA_STORAGE_SETTINGS.VIDEO_RETENTION_PERIOD'|translate }}</div>
              </div>
              <mat-select [placeholder]="'CAMERA_STORAGE_SETTINGS.PLACEHOLDERS.SELECT_PERIOD'|translate"
                          class="ui-selector storage-selector flex ui-selector-40"
                          formControlName="storageMaxDays"
              >
                <mat-option *ngIf="standalone" [value]="null">{{ 'COMMON.NONE'|translate }}</mat-option>
                <mat-option [value]="30">{{ 'DURATION.30DAYS'|translate }}</mat-option>
                <mat-option [value]="60">{{ 'DURATION.60DAYS'|translate }}</mat-option>
                <mat-option [value]="90">{{ 'DURATION.90DAYS'|translate }}</mat-option>
              </mat-select>

            </div>
            <div class="wrapper narrow-input-40 flex-row start-center mb-16">
              <div class="flex-row start-center flex gap-8">
                <!--          <ui-toggle formControlName="maxGbEnabled"></ui-toggle>-->
                <div>{{ 'CAMERA_STORAGE_SETTINGS.MAX_STORAGE'|translate }}</div>
              </div>
              <div class="flex-row start-center p-r flex storage-selector">
                <input class="ui-input w-100 ui-input-40" formControlName="storageMaxGB" max="1024" min="0" placeholder="128"
                       type="number"
                />
                <div class="ui-input-suffix input-40">GB</div>
              </div>

            </div>
            <div class="flex-col gap-8 w-100 mb-24">
              <div>{{ 'CAMERA_STORAGE_SETTINGS.STORAGE_SCHEDULE'|translate }}</div>
              <div class="flex-row w-100">
                <ui-schedule (change)="updateStorageSchedule($event)"
                             [schedule]="storageSchedule"
                             class="flex-row w-100"
                ></ui-schedule>
              </div>
            </div>

            <div class="flex-col start-start gap-5">
              <div *ngIf="!standalone" class="flex-row start-center gap-8">
                <ui-toggle formControlName="smartEnabled"></ui-toggle>
                <div>{{ 'CAMERA_STORAGE_SETTINGS.SMART_STORAGE'|translate }}</div>
              </div>
              <div *ngIf="standalone" class="flex-col start-start gap-8">
                <div>{{ 'CAMERA_STORAGE_SETTINGS.SMART_STORAGE'|translate }}</div>
                <mat-select [placeholder]="'BULK_UPDATE_FORM.PLACEHOLDERS.ENABLE_DISABLE'|translate" class="flex-row ui-selector ui-selector-40"
                            formControlName="smartEnabled">
                  <mat-option [value]="null">{{ 'COMMON.NONE'|translate }}</mat-option>
                  <mat-option [value]="true">{{ 'COMMON.ENABLED'|translate }}</mat-option>
                  <mat-option [value]="false">{{ 'COMMON.DISABLED'|translate }}</mat-option>
                </mat-select>
              </div>
              <div
                class="smart-storage-description">{{ 'CAMERA_STORAGE_SETTINGS.SAVE_ALERT_VIDEO_DESCRIPTION'|translate }}
              </div>
            </div>
            <ng-container *ngIf="smartEnabled">
              <div class="flex-row start-center mt-20">
                <div class="flex start-center">{{ 'CAMERA_STORAGE_SETTINGS.PRE_EVENT_DURATION'|translate }}</div>
                <div class="flex-row p-r flex">
                  <input class="ui-input  w-100 ui-input-40" formControlName="preEventDuration" max="30" min="0" placeholder="10"
                         type="number"
                  />
                  <div class="ui-input-suffix input-40">{{ 'CAMERA_STORAGE_SETTINGS.SEC'|translate }}</div>
                </div>
              </div>
              <div class="flex-row start-center mt-20">
                <div class="flex start-center">Post-Event Duration</div>
                <div class="flex-row p-r flex">
                  <input class="ui-input  w-100 ui-input-40" formControlName="postEventDuration" max="30" min="0" placeholder="5"
                         type="number"
                  />
                  <div class="ui-input-suffix input-40">{{ 'CAMERA_STORAGE_SETTINGS.SEC'|translate }}</div>
                </div>
              </div>
            </ng-container>
          </div>
        </form>
        <div *ngIf="isDeveloper" [formGroup]="storage">
          <div class="seperator"></div>
          <div class="flex-row space-between-center">
            <div *ngIf="!standalone" class="flex-row start-center gap-8">
              <ui-toggle formControlName="additionalEnabled"></ui-toggle>
              <div>{{ 'CAMERA_STORAGE_SETTINGS.ADDITIONAL_STORAGE'|translate }}</div>
            </div>
            <div *ngIf="standalone" class="flex-col start-start gap-8">
              <div>{{ 'CAMERA_STORAGE_SETTINGS.ADDITIONAL_STORAGE'|translate }}</div>
              <mat-select [placeholder]="'BULK_UPDATE_FORM.PLACEHOLDERS.ENABLE_DISABLE'|translate" class="flex-row ui-selector ui-selector-40"
                          formControlName="additionalEnabled">
                <mat-option [value]="null">{{ 'COMMON.NONE'|translate }}</mat-option>
                <mat-option [value]="true">{{ 'COMMON.ENABLED'|translate }}</mat-option>
                <mat-option [value]="false">{{ 'COMMON.DISABLED'|translate }}</mat-option>
              </mat-select>
            </div>
            <div class="flex-col start-start gap-8">
              <div *ngIf="standalone">&nbsp;</div>
              <mat-select [disabled]="!storage.get('additionalEnabled').value"
                          [formControl]="additionalStorageTypeControl"
                          [placeholder]="'CAMERA_STORAGE_SETTINGS.PLACEHOLDERS.SELECT_TYPE'|translate"
                          class="ui-selector storage-selector ui-selector-40"
                          data-track-changes="additionalStorageType"
              >
                <mat-option *ngIf="standalone" [value]="null">{{ 'COMMON.NONE'|translate }}</mat-option>
                <mat-option [value]="storageTypes.Cloud">{{ 'CAMERA_STORAGE_SETTINGS.CLOUD'|translate }}</mat-option>
                <mat-option *ngIf="external?.length"
                            [value]="storageTypes.External">{{ 'CAMERA_STORAGE_SETTINGS.EXTERNAL'|translate }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
        <ng-container
          *ngIf="standalone ? storage.get('additionalEnabled').value !== false : storage.get('additionalEnabled').value">
          <form *ngIf="cloudEnabled" [formGroup]="cloudStorage">
            <div class="flex-col start-start gap-24">
              <ng-container>
                <div class="flex-row space-between-center mt-20 narrower-input w-100 gap-8">
                  <div class="flex">{{ 'CAMERA_STORAGE_SETTINGS.CLOUD_RETENTION_PERIOD'|translate }}</div>
                  <mat-select class="ui-selector storage-selector ui-selector-40"
                              formControlName="cloudRetentionPeriod">
                    <mat-option [value]="30">{{ 'DURATION.30DAYS'|translate }}</mat-option>
                    <mat-option [value]="60">{{ 'DURATION.60DAYS'|translate }}</mat-option>
                    <mat-option [value]="90">{{ 'DURATION.90DAYS'|translate }}</mat-option>
                    <mat-option [value]="180">{{ 'DURATION.180DAYS'|translate }}</mat-option>
                    <mat-option [value]="365">{{ 'DURATION.365DAYS'|translate }}</mat-option>
                  </mat-select>
                </div>
                <div class="flex-col gap-16 w-100">
                  <div>{{ 'CAMERA_STORAGE_SETTINGS.VIDEO_BACKUP'|translate }}</div>
                  <div class="flex-row start-center gap-8">
                    <ui-toggle formControlName="backupStorage"></ui-toggle>
                    <div>{{ 'CAMERA_STORAGE_SETTINGS.STORAGE_SQ'|translate }}</div>
                  </div>
                  <div class="flex-col gap-8 w-100">
                    <div>{{ 'CAMERA_STORAGE_SETTINGS.UPLOAD_VIDE_DESC'|translate }}</div>
                    <div class="flex-row">
                      <ui-schedule (change)="updateFootageSchedule($event)" [class.disabled]="!backupStorage"
                                   [schedule]="footageSchedule"
                                   class="flex-row w-100"
                                   data-track-changes="footageSchedule"
                      ></ui-schedule>
                    </div>
                  </div>
                  <div class="flex-row start-center gap-8">
                    <ui-toggle formControlName="backupAlerts"></ui-toggle>
                    <div>{{ 'CAMERA_STORAGE_SETTINGS.ALERTS_HQ'|translate }}</div>
                  </div>
                  <div class="flex-row start-center gap-8">
                    <ui-toggle formControlName="backupEventTypes"></ui-toggle>
                    <div>{{ 'CAMERA_STORAGE_SETTINGS.EVENT_TYPES'|translate }}</div>
                  </div>
                </div>
                <div class="flex-col gap-8 w-100">
                  <div>{{ 'CAMERA_STORAGE_SETTINGS.WHEN_UPLOAD_SHOULD_OCCUR'|translate }}</div>
                  <div class="flex-row w-100">
                    <ui-schedule (change)="updateUploadSchedule($event)"
                                 [schedule]="uploadSchedule"
                                 class="flex-row w-100"
                                 data-track-changes="uploadSchedule"
                    ></ui-schedule>

                  </div>
                </div>
              </ng-container>
            </div>

          </form>
          <div *ngIf="externalEnabled" [formGroup]="externalStorage">
            <div class="flex-col start-start gap-24">
              <ng-container>
                <div class="flex-row space-between-center gap-8 mt-20 narrower-input w-100">
                  <div class="flex">{{ 'CAMERA_STORAGE_SETTINGS.EXTERNAL_STORAGE'|translate }}</div>
                  <mat-select [placeholder]="'CAMERA_STORAGE_SETTINGS.PLACEHOLDERS.EXTERNAL_STORAGE'|translate"
                              class="ui-selector storage-selector ui-selector-40"
                              formControlName="externalStorageId"
                  >
                    <mat-option *ngIf="standalone" [value]="null">{{ 'COMMON.NONE'|translate }}</mat-option>
                    <mat-option *ngFor="let storage of external" [value]="storage._id">{{ storage?.name }}</mat-option>
                  </mat-select>
                </div>
                <div class="flex-row space-between-center gap-8 mt-20 narrower-input w-100">
                  <div class="flex">{{ 'CAMERA_STORAGE_SETTINGS.EXTERNAL_RETENTION_PERIOD'|translate }}</div>
                  <mat-select class="ui-selector storage-selector ui-selector-40"
                              formControlName="externalRetentionPeriod"
                  >
                    <mat-option *ngIf="standalone" [value]="null">{{ 'COMMON.NONE'|translate }}</mat-option>
                    <mat-option [value]="30">{{ 'DURATION.30DAYS'|translate }}</mat-option>
                    <mat-option [value]="60">{{ 'DURATION.60DAYS'|translate }}</mat-option>
                    <mat-option [value]="90">{{ 'DURATION.90DAYS'|translate }}</mat-option>
                    <mat-option [value]="180">{{ 'DURATION.180DAYS'|translate }}</mat-option>
                    <mat-option [value]="365">{{ 'DURATION.365DAYS'|translate }}</mat-option>
                  </mat-select>
                </div>
                <div class="flex-col gap-16 w-100">
                  <div>{{ 'CAMERA_STORAGE_SETTINGS.VIDEO_BACKUP'|translate }}</div>
                  <div class="flex-row start-center gap-8">
                    <ui-toggle formControlName="backupStorage"></ui-toggle>
                    <div>{{ 'CAMERA_STORAGE_SETTINGS.STORAGE_SQ'|translate }}</div>
                  </div>
                  <div class="flex-col gap-8 w-100">
                    <div>{{ 'CAMERA_STORAGE_SETTINGS.UPLOAD_VIDE_DESC'|translate }}</div>
                    <div class="flex-row">
                      <ui-schedule (change)="updateFootageSchedule($event)" [class.disabled]="!backupStorageExternal"
                                   [schedule]="footageSchedule"
                                   class="flex-row w-100"
                                   data-track-changes="footageScheduleExternal"
                      ></ui-schedule>
                    </div>
                  </div>
                  <div class="flex-row start-center">
                    <ui-toggle class="mr-8" formControlName="backupAlerts"></ui-toggle>
                    <div>{{ 'CAMERA_STORAGE_SETTINGS.ALERTS_HQ'|translate }}</div>
                  </div>
                  <div class="flex-row start-center">
                    <ui-toggle class="mr-8" formControlName="backupEventTypes"></ui-toggle>
                    <div>{{ 'CAMERA_STORAGE_SETTINGS.EVENT_TYPES'|translate }}</div>
                  </div>
                </div>
                <div class="flex-col gap-8 w-100">
                  <div>{{ 'CAMERA_STORAGE_SETTINGS.WHEN_UPLOAD_SHOULD_OCCUR'|translate }}</div>
                  <div class="flex-row w-100">
                    <ui-schedule (change)="updateUploadSchedule($event)"
                                 [schedule]="uploadSchedule"
                                 class="flex-row w-100"
                                 data-track-changes="uploadScheduleExternal"
                    ></ui-schedule>

                  </div>
                </div>
              </ng-container>
            </div>

          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-container>
